export interface ConsumerAccount {
  membershipGroup?: string
  availablePointsBalance?: number
  tierLevel?: string
  tierPointsToNextLevel?: number
  tierTotalPoints?: number
}

export interface ConsumerAccountResponse {
  data?: ConsumerAccount
}

interface ConsumerAccountRequest {
  baseUrl: string
  consumerId: string
  loyaltyEndpoint: string
  headers?: Headers
}

class ConsumerAPI {
  static async getAccount({
    baseUrl,
    consumerId,
    loyaltyEndpoint,
    headers
  }: ConsumerAccountRequest): Promise<ConsumerAccount | undefined> {
    const url = `${baseUrl}${loyaltyEndpoint}/consumers/${consumerId}/membership`

    const response = await fetch(url, {
      method: 'GET',
      headers
    })

    if (!response.ok) {
      throw new Error(`HTTP ${response.status} ${response.statusText}`)
    }

    const { data } = (await response.json()) as ConsumerAccountResponse

    return data
  }
}

export default ConsumerAPI
